<nz-upload
  class="avatar-uploader"
  nzName="avatar"
  nzListType="picture-card"
  [nzAction]="uploadPath"
  [nzShowUploadList]="false"
  [nzBeforeUpload]="beforeUpload"
  (nzChange)="handleChange($event)"
>
  @if (!avatarUrl) {
    <span class="upload-icon" nz-icon [nzType]="fileIsLoading ? 'loading' : 'plus'"></span>
    <div class="ant-upload-text">{{ 'common.upload' | translate }}</div>
  }
  @if (avatarUrl) {
    <img [src]="avatarUrl" style="width: 100%" />
  }
</nz-upload>
